import getOgmaSupportedLanguageTag from '../utils/getOgmaSupportedLanguageTag';
import setOgmaHeaders from './utils/setOgmaHeaders';
import store from '../store/store';
import { getOgmaTranslateUri } from './utils/getOgmaUris';

export default async function translateText(text: string): Promise<string> {
    const promise = new Promise<string>(function(resolve, reject) {
        const xhttp = new XMLHttpRequest();

        xhttp.onload = function() {
            // TODO VSO:2686876 determine how errors here should be presented to user
            if (xhttp.status === 200) {
                const translatedText = JSON.parse(this.responseText).TranslatedText;
                if (translatedText != null) {
                    resolve(translatedText);
                } else {
                    reject('OGMA returned invalid response: ' + this.response);
                }
            } else {
                reject('OGMA failed to translate messaage: ' + this.response);
            }
        };

        xhttp.onerror = function() {
            reject('OGMA call failed: ' + this.response);
        };

        const ogmaCompatibleLanguageTag = getOgmaSupportedLanguageTag(
            store.localeOfSupportedLanguageMap
        );
        xhttp.open('POST', getOgmaTranslateUri(ogmaCompatibleLanguageTag));
        setOgmaHeaders(xhttp);
        xhttp.send(JSON.stringify({ Data: text, DataType: 'html' }));
    });

    return promise;
}
